import React, { useState } from "react";
import { ChevronDown, FileText } from "lucide-react";
import { useCruise } from "../context/CruiseContext";
import TermsContent from "./TermsContent";

const TermsSection = () => {
  const { EVENT } = useCruise();
  const [open, setOpen] = useState(false);

  return (
    <section id="terms" className="bg-[#0A0A0A] border-t border-white/10 py-14">
      <div className="max-w-4xl mx-auto px-5">
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="terms-toggle"
          aria-expanded={open}
          className="w-full flex items-center gap-3 text-left"
        >
          <span className="flex items-center justify-center w-10 h-10 rounded-full bg-[#E50914]/15 text-[#E50914] shrink-0">
            <FileText size={18} />
          </span>
          <span className="flex-1">
            <span className="block font-cond font-bold uppercase tracking-wide text-white text-lg leading-none">
              Terms &amp; Conditions
            </span>
            <span className="block text-white/45 text-xs mt-1">
              Talent, payments, cancellations &amp; more — tap to {open ? "hide" : "read"}
            </span>
          </span>
          <ChevronDown
            size={22}
            className={`text-white/50 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          />
        </button>

        {open && (
          <div className="mt-6 rounded-2xl border border-white/10 bg-[#111111] p-5 sm:p-7">
            <TermsContent eventId={EVENT.id} />
          </div>
        )}
      </div>
    </section>
  );
};

export default TermsSection;
